import React, { useEffect, useState } from 'react';

import { Row, Widget } from '@digital/ui';
import { Button, Modal } from 'antd';
import { verificarAnexoRelatorioHomologacao } from '@app/api/sas/ordemCompra';
import { enviarContratoTotvs } from '@app/api/sas/relatorioHomologacao';
import { useRecoilState, useRecoilValue } from 'recoil';
import { dadosGeraisState, reloadDadosGeraisState, reloadState } from '../atoms';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { ETipoContrato } from '@app/enums/ETipoContrato';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';
import WidgetClausulasAditivo from './WidgetClausulasAditivo';
import { isNullOrUndefined } from '@app/helpers';

interface Props {
  ordemCompraId: string;
}

const ModalGerarContratoTotvs = (props: Props) => {
  const [exibirModal, setExibirModal] = useState(false);
  const [integracaoSucesso, setIntegracaoSucesso] = useState(false);
  const { ordemCompraId } = props;
  const dadosGerais = useRecoilValue(dadosGeraisState);
  const [reload, setReload] = useRecoilState(reloadState); 
  const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState); 
  const [clausulas, setClausulas] = useState<string[]>();

  const ehAditivo = dadosGerais.tipo == ETipoDemanda.Aditivo;
  const ehFaturamentoDireto = dadosGerais.tipo == ETipoDemanda.FaturamentoDireto;
  const numeroOc = dadosGerais.numero;
  const ehPCS = (dadosGerais.modalidadeContratoTotvs || '').toLocaleLowerCase() === ETipoContrato.PCS;
  const disableAditivo = ehAditivo && ((isNullOrUndefined(dadosGerais.isPrazo) || isNullOrUndefined(dadosGerais.isValorSemAcrescimoEscopo)) || 
    (dadosGerais.isPrazo === false && dadosGerais.isValorSemAcrescimoEscopo === false));

  const onCancel = () => {
    setExibirModal(false);
    setIntegracaoSucesso(false);
  };

  const onCancelOk = () => {
    onCancel();
    setReload(!reload);
  }

  const onStart = () => {
    verificarAnexoRelatorioHomologacao(ordemCompraId).then(data => {
      if (data && data.valid) {
        if (data.resultado === true) {
          setExibirModal(true);
        }
        if (data.resultado === false) {
          onCancel();
        }
      }
    });
  };

  const onSend = () => {
    enviarContratoTotvs(ordemCompraId, clausulas).then(data => {
      if (data && data.valid) {
        setIntegracaoSucesso(true);
        setReloadDadosGerais(!reloadDadosGerais);
      }
    });
  };

  const tipo = () => {
    
    if (ehFaturamentoDireto) { 
      if(numeroOc) {
        return "PCS"
      } else {
      return "Faturamento Direto";
      }
    }

    if(ehAditivo){
      if(ehPCS) {
        return "Aditivo PCS"
      } else {
        return "Aditivo"
      }
    } else {
      if(ehPCS) {
        return "PCS"
      } else {
        return "Contrato"
      }
    }
  }

  const buttons = () => {
    const actions = [];
    if (integracaoSucesso) {
      actions.push(
        <Button key="okBtn" type="primary" onClick={() => onCancelOk()}>
          Ok
        </Button>,
      );
    } else {
      actions.push(
        <Button key="discordarBtn" type="danger" onClick={() => onCancel()}>
          Não
        </Button>,
      );

      actions.push(
        <Button key="concordarBtn" type="success" onClick={() => onSend()}>
          Sim
        </Button>,
      );
    }

    return actions;
  };

  return (
    <>
      <Button
        onClick={() => onStart()}
        type="primary"
        className='button-sas-acoes'
        key="gerarContratoBtn"
        style={{ marginLeft: 10 }}
        disabled={
          dadosGerais.statusCodigo == EStatusOrdemCompra.AguardandoExpectativaCompras ||
          disableAditivo ||
          ( ehAditivo
              ? (["Pendente", "Aprovado", "Emitido"].includes(dadosGerais.statusAprovacaoAditivoTotvs))
              : (["Pendente", "Aprovado", "Emitido"].includes(dadosGerais.statusAprovacaoContratoTotvs))
          )
        }
      >
        {`Gerar ${tipo()} Totvs`}
      </Button>
      <Modal
        title={`Gerar ${tipo()} no Totvs`}
        width={ehAditivo && ehPCS ? '1200px' : '680px'}
        visible={exibirModal}
        onCancel={() => onCancel()}
        footer={buttons()}>
        <Widget>
          {integracaoSucesso === false ? (
            <Row style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
              <p>
                Tem certeza que deseja gerar o {tipo()} no Totvs?
              </p>

              {ehAditivo && ehPCS && <WidgetClausulasAditivo onChangeClausulas={setClausulas} />}

            </Row>
          ) : (
            <Row>
              <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                O {tipo()} foi integrado com sucesso.
              </p>
            </Row>
          )}
        </Widget>
      </Modal>
    </>
  );
};

export default ModalGerarContratoTotvs;
